import { QueryClient } from "@tanstack/react-query";
import { catalogKeys, profileKeys, sessionKeys } from "queries/profile.keys";
import type { ProfileCacheData, ProfileType } from "store/types/profile";
import type { SessionUser } from "types/session-user";
import type { UserCatalog } from "types/user-catalog";

export const getSessionFromCache = (queryClient: QueryClient) => {
  return queryClient.getQueryData<SessionUser>(sessionKeys.me());
};

export const getCatalogFromCache = (queryClient: QueryClient) => {
  return queryClient.getQueryData<UserCatalog>(catalogKeys.me());
};

export const updateSessionInCache = (
  queryClient: QueryClient,
  updater: (session: SessionUser) => SessionUser
) => {
  queryClient.setQueryData<SessionUser>(sessionKeys.me(), (session) =>
    session ? updater(session) : session
  );
};

export const updateCatalogInCache = (
  queryClient: QueryClient,
  updater: (catalog: UserCatalog) => UserCatalog
) => {
  queryClient.setQueryData<UserCatalog>(catalogKeys.me(), (catalog) =>
    catalog ? updater(catalog) : catalog
  );
};

export const invalidateSession = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({ queryKey: sessionKeys.all });
};

export const invalidateCatalog = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({ queryKey: catalogKeys.all });
};

/** @deprecated Migrate to getSessionFromCache. */
export const getProfileFromCache = (queryClient: QueryClient) => {
  return queryClient.getQueryData<Partial<ProfileCacheData & ProfileType>>(profileKeys.me());
};

/** @deprecated Migrate to invalidateSession or invalidateCatalog explicitly. */
export const invalidateProfile = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({ queryKey: profileKeys.all });
};
